// Paket 14 Teil C (C-E1, M-07.4): the server answers 409 STALE_* when a form was loaded before someone
// else saved. The server sends its own German text; this is the fallback when the answer has none.
export const staleMessage = 'Inzwischen hat jemand anderes geändert – bitte neu laden.';
export function staleCode(error: unknown): string | null {
  const code = (error as { response?: { data?: { code?: unknown } } })?.response?.data?.code;
  return typeof code === 'string' && code.startsWith('STALE_') ? code : null;
}
